import { Navigate, useOutletContext } from "react-router-dom";
import Reviews from "../components/landing/Reviews";

export default function ReviewsPage() {
  const content = useOutletContext();
  if (content.settings?.showReviews === false) return <Navigate to="/" replace />;
  return <Reviews testimonials={content.testimonials} />;
}
